import { useState } from 'react'

import { applyTheme, storedTheme, type ThemePreference } from '../theme'

const NEXT: Record<ThemePreference, ThemePreference> = {
  system: 'light',
  light: 'dark',
  dark: 'system',
}

const LABEL: Record<ThemePreference, { icon: string; text: string }> = {
  system: { icon: '◐', text: 'Auto' },
  light: { icon: '☀', text: 'Light' },
  dark: { icon: '☾', text: 'Dark' },
}

/** Cycles Auto (follow the system) → Light → Dark. */
export default function ThemeToggle() {
  const [preference, setPreference] = useState(storedTheme)
  const next = NEXT[preference]

  return (
    <button
      type="button"
      className="theme-toggle"
      aria-label={`Theme: ${LABEL[preference].text}. Switch to ${LABEL[next].text}.`}
      title={`Theme: ${LABEL[preference].text} — click for ${LABEL[next].text}`}
      onClick={() => {
        applyTheme(next)
        setPreference(next)
      }}
    >
      <span aria-hidden="true">{LABEL[preference].icon}</span> {LABEL[preference].text}
    </button>
  )
}
